export const colors = (state = [], action) => {
  if (action.type === 'FETCH_COLORS') {
    return action.payload;
  }
  if (action.type === 'CLEAR_COLORS') {
    return [];
  }
  return state;
};

export const color = (state = {}, action) => {
  if (action.type === 'FETCH_COLOR') {
    return action.payload;
  }
  if (action.type === 'CLEAR_COLOR') {
    return {};
  }
  return state;
};

export const colorIds = (state = [], action) => {
  if (action.type === 'FETCH_COLOR_IDS') {
    return action.payload;
  }
  if (action.type === 'CLEAR_COLOR_IDS') {
    return [];
  }
  return state;
};
